ThemeJS.Scroll_Reveal = ( function () {

  function reveal_immediately ( $elements ) {
    $elements.each( function () {
      this.classList.add( 'scroll-reveal', 'is-visible' );
    });
  }

  function init () {
    let $sections = jQuery( 'main section' );
    if ( !$sections.length ) {
      return;
    }

    if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches || !('IntersectionObserver' in window) ) {
      reveal_immediately( $sections );
      return;
    }

    let observer = new IntersectionObserver( function ( entries ) {
      entries.forEach( function ( entry ) {
        if ( !entry.isIntersecting ) {
          return;
        }
        entry.target.classList.add( 'is-visible' );
        observer.unobserve( entry.target );
      });
    }, {
      rootMargin: '0px 0px -6% 0px',
      threshold: 0.06,
    });

    $sections.each( function ( index ) {
      let rect = this.getBoundingClientRect();
      let is_above_fold = index === 0 || rect.top < window.innerHeight * 0.92;

      this.classList.add( 'scroll-reveal' );

      if ( is_above_fold ) {
        this.classList.add( 'is-visible' );
        return;
      }

      observer.observe( this );
    });
  }

  jQuery( init );

  return {
    init
  };

})( jQuery );
